// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

// -- utils
import ArrayUtils from '../../utils/ArrayUtils';

// -- constants
import BookingConstants from '../../constants/BookingConstants';

// -- entities
import BookingSettings from './BookingSettings';
import BookingSlotCapacitySettings from './BookingSlotCapacitySettings';

/**
 * Define the settings for the booking on a day.
 * It defines the capacities and the opening and closing hour.
 */
export default class BookingDayRoomSettings extends ApiObject {

  roomId: string = '';

  capacity: number = 0;

  rules: Array<BookingSlotCapacitySettings> = [];

  postJsonAssignation(data: Object) {
    this.rules = [];
    _.each(data.rules, (ruleData: Object) => {
      const rule:BookingSlotCapacitySettings = new BookingSlotCapacitySettings();
      rule.fromJson(ruleData);
      this.rules.push(rule);
    });
  }

  isValid(bookingSettings: BookingSettings, openingHour, closingHour) {
    if (this.capacity > bookingSettings.maximumCapacity) {
      console.log('BookingDaySettings is invalid (capacity) with the room settings', this);
      return false; // quit loop
    }

    let res = true;
    _.each(this.rules, (slotSetting: BookingSlotCapacitySettings) => {
      if (slotSetting.capacity > bookingSettings.maximumCapacity) {
        res = false;
        console.log('BookingDaySettings is invalid (capacity) with the room settings', this);
        return false; // quit loop
      }

      if (slotSetting.hour < openingHour || slotSetting.hour > closingHour) {
        res = false;
        console.log('BookingDaySettings is invalid (hour) with the room settings', this);
        return false; // quit loop
      }
    });

    return res;
  }

  // -- rules accessor.

  getCapacityForHour(hour: number): number {
    let res = this.capacity;
    _.each(this.rules, (rule: BookingSlotCapacitySettings) => {
      if (rule.hour === hour) {
        res = rule.capacity;
      }
    });

    return res;
  }

  setHourCapacity(hour: number, capacity: number) {
    this.removeCapacityForHour(hour);

    const rule:BookingSlotCapacitySettings = new BookingSlotCapacitySettings();
    rule.hour = hour;
    rule.capacity = capacity;

    this.rules.push(rule);
  }

  removeCapacityForHour(hour: number) {
    const tmp = [];
    _.each(this.rules, (rule: BookingSlotCapacitySettings) => {
      if (rule.hour !== hour) {
        tmp.push(rule);
      }
    });

    this.rules = tmp;
  }

  // -- rules
  addBookingSlotCapacitySettings(bookingSlotCapacitySetting: BookingSlotCapacitySettings) {
    this.rules.push(bookingSlotCapacitySetting);
  }

  updateBookingSlotCapacitySettings(bookingSlotCapacitySettingToUpdate: BookingSlotCapacitySettings) {
    this.rules = ArrayUtils.updateObjectOrAdd(this.rules, bookingSlotCapacitySettingToUpdate,
      (bookingSlotCapacitySetting: BookingSlotCapacitySettings) => {
      return bookingSlotCapacitySettingToUpdate.id === bookingSlotCapacitySetting.id;
    });
  }

  deleteBookingSlotCapacitySettings(bookingSlotCapacitySetting: BookingSlotCapacitySettings) {
    const tmp = [];

    _.each(this.rules, (rule: BookingSlotCapacitySettings) => {
      if (rule.id !== bookingSlotCapacitySetting.id) {
        tmp.push(rule);
      }
    });

    this.rules = tmp;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/booking/BookingDayRoomSettings.js